import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WorkItemDetailModule } from './../work-item-detail/work-item-detail.module';
import { WorkItemPreviewPanelComponent } from './work-item-preview-panel.component';


export class WorkItemPreviewPanelModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    WorkItemDetailModule
  ],
  declarations: [
    WorkItemPreviewPanelComponent
  ],
  exports: [
    WorkItemPreviewPanelComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
